import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { getWorkAssignmentsByJobId } from 'wisestep-api';
import { ScrollableTabs, IUserDTO } from 'wisestep-base';

import { useUserContext } from '../../../../../context';
import { assignments, getEmailsFromAssignments } from '../../../helper';
import { IWorkAssignments } from '../../types';
import AssignedRecruiters from '../AssignedRecruiters';
import RecruitersList from '../RecruitersList';

export interface IRecruitersTableProps {
  jobId: string;
  workAssignments: IWorkAssignments;
}

const RecruitersTable = ({ jobId, workAssignments }: IRecruitersTableProps) => {
  const methods = useForm();
  const recruiter = useUserContext().userDTO as IUserDTO;

  assignments.assignedByRecruiterId = recruiter?.email ?? '';
  assignments.jobDTOList = [jobId];

  const [tabPanelPage, setTabPanelPage] = useState(0);

  const [refresh, setRefresh] = useState<boolean>(false);

  const [recruiterWorkAssignments, setRecruiterWorkAssignments] =
    useState<IWorkAssignments>(workAssignments);

  const assignedRecruitersEmails = getEmailsFromAssignments(recruiterWorkAssignments);

  useEffect(() => {
    const getWorkAssignments = async () => {
      const assignedToData = await getWorkAssignmentsByJobId(jobId);
      setRecruiterWorkAssignments(assignedToData.data);
    };
    getWorkAssignments();
  }, [jobId, refresh]);

  const onAssign = async () => {
    setRefresh(!refresh);
    setTabPanelPage(1);
  };

  return (
    <>
      <FormProvider {...methods}>
        <ScrollableTabs
          scrollList={[
            { tabName: 'Choose Recruiters' },
            {
              tabName: 'Assigned',
              tabCount: assignedRecruitersEmails?.length ?? 0,
            },
          ]}
          getTabIndex={setTabPanelPage}
          defaultValue={tabPanelPage}
        />
        {tabPanelPage === 0 && (
          <Grid container p={3} mb={5}>
            <RecruitersList
              jobId={jobId}
              onAssign={onAssign}
              workAssignments={recruiterWorkAssignments}
            />
          </Grid>
        )}
        {tabPanelPage === 1 && (
          <Grid container p={2}>
            <AssignedRecruiters
              workAssignments={recruiterWorkAssignments}
              jobId={jobId}
              refreshJob={onAssign}
            />
          </Grid>
        )}
      </FormProvider>
    </>
  );
};

export default RecruitersTable;
